export function isEmpty(history: HistoryLog): boolean {
  return !history.length;
}
